import { Box } from '@mui/material';
import { React } from 'Imports';

const styles = require('./Layouts.scss') as {
    panelButtonContainer: string;
    panelButton: string;
};

interface SidePanelVerticalButtonProps {
    onClick: () => void;
    text: string;
}

const SidePanelVerticalButton = (props: SidePanelVerticalButtonProps) => {
    return (
        <div className={styles.panelButtonContainer}>
            <Box className={styles.panelButton} onClick={props.onClick}>
                {props.text}
            </Box>
        </div>
    );
};

export default SidePanelVerticalButton;
